import Icons from "../../assets/icon/index";
import { IoClose } from "react-icons/io5";
import {
  HoverButton,
  FormInput,
  PrefilledDropDown,
  DefaultValueCountry,
  Newlogo,
  Text,
} from "../../components";
import localimgpath from "../../js/localimgpath";
import { FiEdit2 } from "react-icons/fi";
import Functions from "./index.function";
import { BiSolidEdit } from "react-icons/bi";
import { fontSizes } from "../../constants/constants";
const UpdateEmployer = () => {
  const {
    loadingToapi,
    setCountryCode,
    isDragging,
    handleFileChange,
    clearFileChange,
    handleDrop,
    handleDragEnter,
    handleDragLeave,
    handleSubmit,
    register,
    control,
    errors,
    dropdowns,
    isLoading,
    states,
    isLoadingStates,
    cities,
    citiesisLoading,
    onSubmit,
    files,
    employerData,
    isLoadingprefilled,
    industriesData,
    setValue,
    navigate,
    TextWeight,
  } = Functions();
  return (
    <div className={`bg-primary`}>
      <div className="lg:py-10 max-w-7xl lg:px-5 xl:px-10  sm:px-5 xs:px-3 m-auto">
        <div className="flex justify-center items-center relative xs:py-5">
          <Newlogo />
          <div className="absolute top-1/2 -translate-y-1/2 right-5 lg:right-10 xl:right-0">
            <div className="flex justify-between items-center gap-3">
              <Text
                text="Profile"
                color="text-secondary"
                size={fontSizes.h21}
                weight={TextWeight.Onest_regular}
              />
              <button
                onClick={() => navigate("/user-update")}
                className={`bg-[#707070] rounded-full transition-transform transform hover:scale-105 hover:shadow-md xs:w-7 xs:h-7 sm:w-8 sm:h-8 lg:w-10 lg:h-10 flex items-center justify-center`}
              >
                <BiSolidEdit className="text-secondary text-lg sm:text-xl lg:text-2xl" />
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="max-w-7xl lg:px-5 xl:px-10  sm:px-5 xs:px-3 m-auto">
        <div className="flex justify-center items-center flex-col relative lg:py-8">
          <h1 className="uppercase text-secondary font-unboundedBold lg:text-3xl lg:leading-tight">
            Update Account
          </h1>
          <p className="text-secondary lg:pt-5 font-montserratMedium xs:text-xs lg:text-lg">
            Welcome! Please enter your details.
          </p>
        </div>
        {employerData?.logo ? (
          <div className="mt-7 sm:mt-5 w-full flex justify-center items-center">
            <div className="relative w-28 h-28 sm:w-40 sm:h-40 rounded-full border-[3px] sm:border-4 border-goldMetallic group">
              <img
                className="w-full h-full object-contain rounded-full"
                src={
                  files.logo
                    ? URL.createObjectURL(files.logo)
                    : `${localimgpath?.companyLogo}/${employerData?.logo}`
                }
                alt="emp logo"
              />
              {/* Edit Icon Overlay */}
              <label
                htmlFor="logo_Upload"
                className="absolute bottom-1.5 right-0 sm:right-1.5 bg-[#393939] text-secondary p-1.5 rounded-full cursor-pointer transition duration-300 group-hover:scale-110 hover:bg-orangeCrayola"
                title="Edit Image"
              >
                <FiEdit2 className="text-base sm:text-lg" />
              </label>
              {/* Hidden File Input */}
              <input
                id="logo_Upload"
                type="file"
                accept="image/*"
                name="logo"
                onChange={handleFileChange}
                className="hidden"
              />
            </div>
          </div>
        ) : (
          ""
        )}
        <form
          className="flex justify-center items-center flex-col"
          onSubmit={handleSubmit(onSubmit)}
        >
          <div
            className={
              "flex xs:flex-col xs:w-full sm:w-[90%] lg:w-[70%] sm:gap-2 lg:gap-4"
            }
          >
            <div className="relative mt-[18px] xs:w-full sm:w-1/2 lg:w-1/2">
              <FormInput
                label={"Company Name/Name"}
                control={control}
                userData={employerData}
                name="name"
                type="text"
                placeholder="Name"
                errors={errors}
                isMandatory={true}
              />
            </div>
            <div className="relative mt-[18px] xs:w-full sm:w-1/2 lg:w-1/2">
              <FormInput
                label={"Contact Email"}
                control={control}
                userData={employerData}
                isdisabled={true}
                name="email"
                type="email"
                // maxLength={30}
                placeholder="Email"
                errors={errors}
                isMandatory={true}
              />
            </div>
          </div>
          <div
            className={
              "flex xs:flex-col xs:w-full sm:w-[90%] lg:w-[70%] sm:gap-2 lg:gap-4"
            }
          >
            <div className="relative mt-[18px] xs:w-full sm:w-1/2 lg:w-1/2">
              <PrefilledDropDown
                control={control}
                errors={errors}
                rightIcon={Icons.arrowIcon}
                label="Country"
                options={dropdowns?.country || []}
                valueName="country"
                valueoption="country_id"
                name="countries"
                isLoadingpreFiled={isLoadingprefilled}
                isLoading={isLoading}
                isMandatory={true}
              />
            </div>
            <div className="relative mt-[18px] xs:w-full sm:w-1/2 lg:w-1/2">
              <PrefilledDropDown
                control={control}
                errors={errors}
                rightIcon={Icons.arrowIcon}
                label={"Province / State"}
                options={states}
                valueName="state"
                valueoption="state_id"
                name={"state_id"}
                isLoadingpreFiled={isLoadingprefilled}
                isLoading={isLoadingStates}
                isMandatory={true}
              />
            </div>
          </div>
          <div
            className={
              "flex xs:flex-col xs:w-full sm:w-[90%] lg:w-[70%] sm:gap-2 lg:gap-4"
            }
          >
            <div className="relative mt-[18px] xs:w-full sm:w-1/2 lg:w-1/2">
              <PrefilledDropDown
                control={control}
                errors={errors}
                rightIcon={Icons.arrowIcon}
                label={"City"}
                options={cities}
                valueName="city"
                valueoption="city_id"
                name={"city_id"}
                isLoadingpreFiled={isLoadingprefilled}
                isLoading={citiesisLoading}
                isMandatory={true}
              />
            </div>
            <div className="relative mt-[18px] xs:w-full sm:w-1/2 lg:w-1/2">
              <FormInput
                label={"Post Code"}
                control={control}
                userData={employerData}
                name="zip_code"
                type="text"
                placeholder="Post Code"
                errors={errors}
                isMandatory={true}
              />
            </div>
          </div>
          <div
            className={
              "flex xs:flex-col xs:w-full sm:w-[90%] lg:w-[70%] sm:gap-2 lg:gap-4"
            }
          >
            <div className="relative mt-[18px] w-full">
              <FormInput
                label={"Address"}
                control={control}
                userData={employerData}
                name="address_line_1"
                type="text"
                placeholder="Address"
                errors={errors}
                isMandatory={true}
              />
            </div>
          </div>
          <div
            className={
              "flex xs:flex-col xs:w-full sm:w-[90%] lg:w-[70%] sm:gap-2 lg:gap-4"
            }
          >
            <div className="relative mt-[18px] w-full">
              <DefaultValueCountry
                control={control}
                label="Contact phone"
                type="text"
                name="contact_number"
                defaultValue={employerData?.phone}
                countryCode={employerData?.country_code}
                register={register}
                onChange={(value) => setValue("contact_number", value)}
                errors={errors}
                setCountryCode={setCountryCode}
                isMandatory={true}
              />
            </div>
          </div>
          <div
            className={
              "flex xs:flex-col xs:w-full sm:w-[90%] lg:w-[70%] sm:gap-2 lg:gap-4"
            }
          >
            <div className="relative mt-[18px] xs:w-full sm:w-1/2 lg:w-1/2">
              <FormInput
                label="Company Website"
                name="website"
                control={control}
                userData={employerData}
                type="text"
                maxLength={100}
                pattern={{
                  value:
                    /^(https?:\/\/)?([\w-]+\.)+[\w-]{2,}(\/[\w-./?%&=]*)?$/,
                  message:
                    "Please enter a valid URL (e.g., https://example.com)",
                }}
                errors={errors}
                isLoading={isLoading}
                isRequired={true}
              />
            </div>
            <div className="relative mt-[18px] xs:w-full sm:w-1/2 lg:w-1/2">
              <PrefilledDropDown
                control={control}
                errors={errors}
                rightIcon={Icons.arrowIcon}
                label={"Company Industry"}
                options={industriesData?.industries}
                valueName="industry"
                valueoption="industry_id"
                name="industry"
                isLoadingpreFiled={isLoadingprefilled}
                isLoading={isLoading}
                isMandatory={true}
              />
            </div>
          </div>
          <div
            className={
              "flex xs:flex-col xs:w-full sm:w-[90%] lg:w-[70%] sm:gap-2 lg:gap-4"
            }
          >
            <div className="relative mt-[18px] xs:w-full sm:w-1/2 lg:w-1/2">
              <FormInput
                label="Company Size"
                type="text"
                name="no_of_employees"
                control={control}
                userData={employerData}
                errors={errors}
                isLoading={isLoading}
                isMandatory={true}
              />
            </div>
            <div className="relative mt-[18px] xs:w-full sm:w-1/2 lg:w-1/2">
              <FormInput
                label="Business Registration Number"
                type="text"
                name="registration_number"
                control={control}
                userData={employerData}
                maxLength={30}
                errors={errors}
                isLoading={isLoading}
                isMandatory={true}
              />
            </div>
          </div>
          <div
            className={
              "flex xs:flex-col xs:w-full sm:w-[90%] lg:w-[70%] sm:gap-2 lg:gap-4"
            }
          >
            <div className="relative mt-[18px] w-full">
              <FormInput
                label="Contact Person Name"
                type="text"
                name="contact_person"
                control={control}
                userData={employerData}
                errors={errors}
                isLoading={isLoading}
                isMandatory={true}
              />
            </div>
          </div>
          {!employerData?.logo && (
            <div className="flex sm:gap-2 lg:gap-4 xs:w-full sm:w-[90%] lg:w-[70%]">
              <div className="xs:py-2 sm:py-3 lg:py-4 w-full">
                <div className="xs:mb-2 xs:pl-8 sm:mb-2 sm:pl-7 lg:mb-5 lg:pl-8">
                  <p className="xs:text-lg lg:text-lg font-josefinSansRegular text-secondary">
                    Company Logo
                  </p>
                </div>
                <div
                  className={`bg-[#171717] xs:px-4 rounded-3xl flex flex-col ${
                    files.logo
                      ? "justify-center items-start xs:py-4 sm:py-5 sm:px-4 lg:px-10 lg:py-5"
                      : "justify-center items-center xs:py-5 sm:py-6 lg:py-10"
                  } ${
                    isDragging.logo
                      ? "border-2 border-dashed border-orangeCrayola"
                      : "border-dashed border-transparent"
                  }`}
                  onDrop={(e) => handleDrop(e, "logo")}
                  onDragOver={(e) => e.preventDefault()}
                  onDragEnter={() => handleDragEnter("logo")}
                  onDragLeave={() => handleDragLeave("logo")}
                >
                  {files.logo ? (
                    <div className="flex w-full justify-between items-center">
                      <div className="flex items-center xs:gap-1 sm:gap-2 lg:gap-2">
                        <div>
                          <img
                            className="sm:w-10 xs:w-8 lg:w-11"
                            src={URL.createObjectURL(files.logo)}
                            alt={files.logo.name}
                          />
                        </div>
                        <div>
                          <p className="text-[#808080] font-onestRegular xs:text-sm sm:text-sm lg:text-lg">
                            {files.logo.name}
                          </p>
                          <p className="text-[#808080] font-onestLight xs:text-sm sm:text-sm lg:text-lg">
                            {files.logo.size < 1024 * 1024
                              ? `${(files.logo.size / 1024).toFixed(2)} KB`
                              : `${(files.logo.size / (1024 * 1024)).toFixed(
                                  2
                                )} MB`}
                          </p>
                        </div>
                      </div>
                      <div
                        className="group flex justify-center items-center xs:w-5 xs:h-5 sm:w-7 sm:h-7 lg:w-8 lg:h-8 rounded-full bg-[#393939] cursor-pointer transform transition-transform duration-300 hover:scale-110 hover:bg-red-700"
                        onClick={() => clearFileChange("logo")}
                      >
                        <IoClose className="text-secondary xs:text-lg sm:text-xl lg:text-2xl transform transition-transform duration-300 group-hover:rotate-180" />
                      </div>
                    </div>
                  ) : (
                    <>
                      <img src={Icons.uploadIcon} alt="logo_Upload" />
                      <div className="xs:pt-1 lg:pt-3 text-center">
                        <label
                          htmlFor="logo_Upload"
                          className="font-onestRegular xs:text-sm text-[#808080] cursor-pointer"
                        >
                          Drag & Drop or Click to Upload Image
                        </label>
                        <input
                          id="logo_Upload"
                          type="file"
                          accept="image/*"
                          name="logo"
                          onChange={handleFileChange}
                          className="hidden"
                        />
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          )}
          <div className="flex justify-center flex-col items-center my-10 lg:my-8">
            <HoverButton
              extraClasses={`group xs:w-56 xs:h-10 sm:w-60 sm:h-12 lg:w-64 bg-cover flex lg:h-12 text-secondary font-onestMedium items-center justify-center rounded-full transition-transform transform ${
                loadingToapi
                  ? ""
                  : "cursor-pointer hover:scale-105 hover:shadow-md"
              } `}
              BtnTitle={
                loadingToapi ? (
                  <div className="flex justify-center items-center">
                    <div className="animate-spin rounded-full border-t-2 border-b-2 border-secondary h-12 w-12 lg:w-10 lg:h-10  md:w-8 md:h-8 sm:w-10 sm:h-10 xs:w-8 xs:h-8"></div>
                  </div>
                ) : (
                  "Submit"
                )
              }
              disabled={loadingToapi}
              type={"submit"}
              BtnTitleClasses={`text-secondary font-onestSemiBold sm:text-sm lg:text-lg transition-transform transform ${
                loadingToapi
                  ? ""
                  : "group-hover:scale-110 group-hover:text-primary"
              } `}
            />
          </div>
        </form>
      </div>
    </div>
  );
};
export default UpdateEmployer;
